var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"in-dm-frame"},[_c(_setup.InDmHeader,{attrs:{"picture-url":_vm.pictureUrl,"screen-name":_vm.screenName}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('el-input',{staticClass:"in-dm-frame__input",attrs:{"placeholder":"メッセージ...","disabled":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }